import { motion } from 'framer-motion';
import './Valoracion_funcional.css';

export default function ValoracionFuncional() {
  const tarifas = [
    {
      key: 'std',
      title: 'Estándar',
      price: 75,
      desc: 'pensada para aquellos que quieran empezar a entrenar',
      features: [
        { name: '2 sesiones a la semana' },
        { name: '8 personas máximo' }
      ]
    },
    {
      key: 'prm',
      title: 'Premium',
      price: 100,
      desc: 'pensada para una experiencia completa',
      features: [
        { name: 'Sesiones ilimitadas' },
        { name: '8 personas máximo' },
        { name: 'Servicios de fisioterapia y rehabilitación', value: '10% dto' }
      ]
    }
  ];

  return (
    <div className="valoracion-container">
      <motion.h1
        className="valoracion-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        ENTRENAMIENTO FUNCIONAL
      </motion.h1>

      <motion.div
        className="valoracion-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.8 }}
      >
        <h2>Descripción:</h2>
        <p className="valoracion-desc">
          Si lo que buscas es un lugar donde engancharte al entrenamiento, mantener una vida activa y saludable, y desconectar del estrés diario, este es tu sitio.
          <br />
          <br />
          Con nuestro servicio de entrenamiento personal, encontrarás una experiencia totalmente adaptada a ti: tus objetivos, tu ritmo, tu bienestar.
          <br />
          <br />
          Te acompañamos en el proceso con cercanía, profesionalidad y motivación, para que entrenar se convierta en tu momento preferido del día.
        </p>
      </motion.div>

      <motion.div
        className="valoracion-precios"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        {tarifas.map(plan => (
          <div key={plan.key} className={`valoracion-precio-cell ${plan.key}`}>
            <h3 className="precio-title">
              Tarifa <span className="accent">{plan.title}</span>
            </h3>
            <div className="price-pill">{plan.price} €</div>
            <p className="valoracion-desc">{plan.desc}</p>

            <ul className="precio-features">
              {plan.features.map((f, idx) => (
                <li key={idx}>
                  <span>{f.name}</span>
                  {f.value && <span className="feature-value">{f.value}</span>}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </motion.div>

      <motion.div
        className="valoracion-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.8 }}
      >
        <h2>Algunas observaciones</h2>
        <p>– las reservas se realizarán de forma online a través de una aplicación móvil en los horarios pre-establecidos.</p>
        <p>– los entrenamientos son supervisados por profesionales graduados en CAFYD con la cualificación necesaria para adaptar los trabajos a tu situación individual.</p>
      </motion.div>
    </div>
  );
}